<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="toc-title">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/04_Introduction#intro">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/05_Timeline#time">Timeline</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Glossary#gloss">Glossary</a></h2>
<h2 class="toct"><span href="#/xhtml/07_Chapter01#chapter1" title="Link target outside of Sample">Chapter 1: Origins</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02#chapter2" title="Link target outside of Sample">Chapter 2: Assessment, Selection and Training</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03#chapter3" title="Link target outside of Sample">Chapter 3: Tools of the Trade</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04#chapter4" title="Link target outside of Sample">Chapter 4: Operations</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05#chapter5" title="Link target outside of Sample">Chapter 5: The End of an Adventure</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06#chapter6" title="Link target outside of Sample">Chapter 6: Epilogue</span></h2>
<h2 class="toct"><span href="#/xhtml/13_Sources#source" title="Link target outside of Sample">Sources and Bibliography</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Acknowledgements#ack" title="Link target outside of Sample">Acknowledgements</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?a227c242